import { render } from "./TableData3Setting.vue?vue&type=template&id=7d16b2d4&scoped=true"
import script from "./TableData3Setting.vue?vue&type=script&lang=js"
export * from "./TableData3Setting.vue?vue&type=script&lang=js"

import "./TableData3Setting.vue?vue&type=style&index=0&id=7d16b2d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d16b2d4"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData3Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d16b2d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d16b2d4', __exports__)) {
    api.reload('7d16b2d4', __exports__)
  }
  
  module.hot.accept("./TableData3Setting.vue?vue&type=template&id=7d16b2d4&scoped=true", () => {
    api.rerender('7d16b2d4', render)
  })

}


export default __exports__